import { NewEntityId } from "../../data/constants";
import {
  ModuleCertificateValidity,
  ModuleStatus,
  ModuleType,
  ModuleViewModel,
  RequiredModule,
} from "../../model/Module";

export const initialModule: ModuleViewModel = {
  id: NewEntityId,
  nameDE: "",
  nameEN: "",
  nameFR: "",
  nameIT: "",
  moduleType: ModuleType.OptionalModule,
  certificateValidity: ModuleCertificateValidity.Unlimited,
  status: ModuleStatus.Draft,
  exams: [],
  allowOptions: false,
  allowDocumentUpload: true,
  verificationRequired: false,
  price: undefined,
  abacusNumber: "",
  gradingRule: undefined,
  allowRegistrationOnlyOnce: false,
};

export const getInitialRequiredFieldsStatuses = (): RequiredModule => ({
  isNameDEEmpty: false,
  isNameENEmpty: false,
  isNameFREmpty: false,
  isNameITEmpty: false,
  isPriceEmpty: false,
  isGradingRuleEmpty: false,
});
